export enum AvailabilityType {
    None = 0,
    PostPayment = 1 << 0,
    PrePayment = 1 << 1,
}